import { createFormViewContainer } from 'factories/FormView'
import { createChildItemsDispatchToProps } from 'helpers/formViews'
import actions from 'actions/issueLimitLists'
import locationActions from 'actions/locations'
import issueLimitListsItemsActions from 'actions/issueLimitLists/issueLimitListItems'
import Component from 'components/IssueLimitLists/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    newItem: (params) => dispatch(actions.newItem(params)),
    getLocations: (params) =>
      dispatch(
        locationActions.getItems({ ...params, locationVendingTypes: ['NonVending'], active: 'Active' })
      ),
    populateIssueLimitListItems: (issueLimitListId, params) =>
      dispatch(issueLimitListsItemsActions.populateIssueLimitListItems(issueLimitListId, params)),
    ...createChildItemsDispatchToProps(dispatch, 'IssueLimitList', issueLimitListsItemsActions),
  }),
})(Component)
